import { useEffect } from "react";
import { Classes } from "../../theme/Classes"

export const FormButton = ({ title, role, onClick, children, style={} }) => {

    return (
        <>
        {(role === "primary") &&
        <button onClick={onClick}  style={{...Classes.Button.Primary,...style}}>
            {children}
        </button>}
        {(role === "secondary") &&
        <button onClick={onClick}  style={{...Classes.Button.Secondary,...style}}>
            {children}
        </button>}
        </>
    )
}